if (`${import.meta.env.VITE_FORCE_SW_RESET}` === "1") {
  if (localStorage.getItem("sw:reset_done") !== "1") {
    navigator.serviceWorker?.getRegistrations?.().then((regs) => {
      Promise.allSettled(regs.map((r) => r.unregister())).then(() => {
        localStorage.setItem("sw:reset_done", "1");
        location.reload();
      });
    });
  }
}

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import setupDayjs from "utils/dayjs.js";
import setupSentry, { isChunkLoadError } from "utils/sentry";
import { startFocusRefresh } from "utils/axios";
import { registerAppUpdate } from "utils/appUpdate";
import {
  hasPendingChunkRepair,
  recoverFromChunkError,
  repairPendingChunks,
} from "utils/chunkRecovery";

import "assets/styles/global.css";
import "react-chat-elements/dist/main.css";

setupDayjs();
setupSentry();
// Refresh token proaktif hanya saat tab fokus (tab background tidak refresh)
startFocusRefresh();

// Semua dynamic import yang gagal lewat event ini, termasuk error runtime di
// dalam modulnya → filter hanya chunk yang gagal di-load (chunk hilang / cache
// rusak setelah deploy). Tidak di-preventDefault supaya error tetap sampai ke
// ErrorPage / ChunkErrorFallback yang menampilkan status pemulihan.
window.addEventListener("vite:preloadError", (event) => {
  if (isChunkLoadError(event.payload)) {
    recoverFromChunkError(event.payload, "vite_preload");
  }
});

const start = () => {
  // Versi baru tidak di-reload paksa — notifikasinya di UpdateAppWrapper
  registerAppUpdate();

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// Setelah reload pemulihan chunk: perbaiki cache aset dulu sebelum SW
// didaftarkan ulang (supaya precache tidak ikut menyimpan file rusak).
if (hasPendingChunkRepair()) {
  repairPendingChunks().finally(start);
} else {
  start();
}
